import React from 'react';
import styled from 'styled-components';
import { VideoType } from './types';
import { screenSmMin, Text, cssColorValue } from '@spotify-internal/encore-web';
import { useReduxVideos } from './useReduxVideos';
import { ContentfulImage } from '@spotify-internal/frodor-modules';
import { ImageAspectBox16x9 } from '../ui';
import { InteractiveElement } from '../../utils/InteractiveElement';
import { TrackVisibility } from '../../utils/Visibility/TrackVisibility';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  a {
    color: ${cssColorValue('textBase')} !important;
    text-decoration: none !important;
  }
  .image {
    &::before {
      background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2272px%22%20height%3D%2272px%22%20viewBox%3D%220%200%2072%2072%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0D%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2049.2%20%2851160%29%20-%20http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch%20--%3E%0D%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0D%0A%20%20%20%20%3Cdefs%3E%0D%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2235.6%22%20cy%3D%2235.6%22%20r%3D%2235.6%22%3E%3C%2Fcircle%3E%0D%0A%20%20%20%20%3C%2Fdefs%3E%0D%0A%20%20%20%20%3Cg%20id%3D%22Video-Pages%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0D%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Artboard-2%22%20transform%3D%22translate%28-932.000000%2C%20-651.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22VideoHomeThumbnails-Copy-7%22%20transform%3D%22translate%28767.000000%2C%20574.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-3%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PlayButton%22%20transform%3D%22translate%28165.000000%2C%2077.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Oval%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill-opacity%3D%220.5%22%20fill%3D%22%23000000%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%222.8%22%20cx%3D%2235.6%22%20cy%3D%2235.6%22%20r%3D%2234.2%22%3E%3C%2Fcircle%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Shape%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%20points%3D%2250.7515152%2035.3703704%2025.6%2020%2025.6%2050.7407407%22%3E%3C%2Fpolygon%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%3C%2Fg%3E%0D%0A%3C%2Fsvg%3E');
      background-size: cover;
      content: '';
      display: block;
      height: 57px;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      transition: opacity 0.3s;
      width: 57px;
      z-index: 1;
    }

    @media (min-width: ${screenSmMin}) {
      &::before {
        height: 71px;
        opacity: 0;
        width: 71px;
      }
    }
  }
  &:hover {
    .image {
      ::before {
        opacity: 1;
      }
    }
    .title {
      text-decoration: underline;
    }
  }
`;
const StyledImage = styled(ContentfulImage)`
  padding-bottom: '16px';
`;

const VideoImageContainer = styled(ImageAspectBox16x9)`
  display: block;
  position: relative;
`;

export const VideoTile = ({
  video,
  className,
}: {
  video: VideoType;
  className?: string;
}) => {
  const { videoCategories } = useReduxVideos();

  const category = videoCategories.byId[video.category];
  return (
    <Wrapper
      className={className ? 'new-videos '.concat(className) : 'new-videos'}
    >
      <TrackVisibility
        threshold={0.4}
        eventCategory="Frodor - video tile"
        eventLabel={video.name}
      >
        <InteractiveElement
          href={`/video/${video.urlSlug}`}
          trackingLabel={`Video - ${video!.name}`}
          trackingCategory="Videos"
        >
          <VideoImageContainer className="image">
            <StyledImage
              asset={(video as $TSFixMe).thumbnailAsset}
              format={['jpg', 'progressive']}
              assetWidth={764 / 1}
              imageStyle={{
                marginLeft: 'auto',
                marginRight: 'auto',
                paddingBottom: '16px',
              }}
              placeholder={false}
            />
            \
          </VideoImageContainer>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Text
              className="title"
              variant="titleSmall"
              semanticColor="textBase"
              paddingBottom="tighter-4"
            >
              {video.name}
            </Text>
            {category.groups.length > 1 && (
              <Text variant="bodySmallBold" paddingBottom="tighter">
                {category.name}
              </Text>
            )}
            <Text variant="bodyMedium"> {video.body}</Text>
          </div>
        </InteractiveElement>
      </TrackVisibility>
    </Wrapper>
  );
};
